import FlightTrackerSearchControls from './FlightTrackerSearchControls';

export default FlightTrackerSearchControls;
